import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
    const colorValue = semanticVariables?.[`semantic_icon_${color}`];
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M12.7881 6.62057L15.5731 12.1694L9.6933 17.5334M12.7881 6.62057L10.4689 1.99976L4.79688 22.0002L9.6933 17.5334M12.7881 6.62057L14.0985 1.99976L19.2033 12.1694L8.42652 22.0002L9.6933 17.5334"
                stroke={colorValue}
                stroke-width="1.5"
                stroke-linejoin="round"
            />
        </svg>
    );
};
